import BranchHelper from "../core/BranchHelper";
import { ServiceItemTypes } from "../core/Constants";
import Utils from "../core/Utils";
import { getBranch } from "../data/localSettingsActions";
import Big from "big.js";

const adjustTaxIfNeeded = (
  inclusiveOfTax,
  calculatedTotalAmount,
  totalPriceIncludingTax,
  taxAmount,
  taxPercent,
  totalPrice
) => {
  const branchDetails = getBranch();
  let municipalAmount = 0;
  if (!inclusiveOfTax || calculatedTotalAmount === totalPriceIncludingTax) {
    if (branchDetails.isAllowMunicipalTax && taxPercent) {
      const _totalPrice = Utils.ConvertToFloat(totalPriceIncludingTax);
      const _municipalTax = Utils.ConvertToFloat(branchDetails.municipalTax);
      const _taxPercent = Utils.ConvertToFloat(taxPercent);

      const totalTaxPercent = Utils.ConvertToFloat(_municipalTax + _taxPercent);

      const basePrice = +(_totalPrice / (1 + totalTaxPercent / 100));
      // municipalAmount = +(basePrice * (_municipalTax / 100)).toFixed(2);
      // taxAmount = +(basePrice * (_taxPercent / 100)).toFixed(2);
      municipalAmount = +(basePrice * (_municipalTax / 100));
      taxAmount = +(basePrice * (_taxPercent / 100));
      return [taxAmount, municipalAmount];
    }
    return [taxAmount, municipalAmount];
  }
  var diff = Utils.ConvertToFloat(
    calculatedTotalAmount - totalPriceIncludingTax
  );
  taxAmount = Utils.ConvertToFloat(taxAmount - diff);
  return [taxAmount, municipalAmount];
};

export const getTotalPrice = (price, quantity) => {
  return Utils.ConvertToFloat((price * quantity).toFixed(2));
};

export const getTaxAmount = (
  inclusiveOfTax,
  taxPercent,
  totalPrice,
  totalPriceIncludingTax
) => {
  let municipalTaxAmount = 0;
  if (inclusiveOfTax) {
    var taxAmount = Utils.ConvertToFloat(totalPriceIncludingTax - totalPrice);
    var calculatedTotalAmount = totalPrice + taxAmount;
    var totalAmount = adjustTaxIfNeeded(
      inclusiveOfTax,
      calculatedTotalAmount,
      totalPriceIncludingTax,
      taxAmount,
      taxPercent,
      totalPrice
    );
    taxAmount = totalAmount[0];
    municipalTaxAmount = totalAmount[1];
    return [taxAmount, municipalTaxAmount];
  } else {
    let branchDetails = getBranch();
    if (branchDetails.isAllowMunicipalTax) {
      const _basePrice = Utils.ConvertToFloat(totalPrice);
      const _municipalTax = Utils.ConvertToFloat(branchDetails.municipalTax);
      const _taxPercent = Utils.ConvertToFloat(taxPercent);

      const taxAmount = _basePrice * (_taxPercent / 100).toFixed(2);
      const municipalAmount = _basePrice * (_municipalTax / 100).toFixed(2);
      const totalSumPrice = taxAmount + municipalAmount;
      return [taxAmount, municipalAmount];
    }
    return [
      Utils.ConvertToFloat((totalPrice * (taxPercent / 100)).toFixed(2)),
      municipalTaxAmount,
    ];
  }
};

export const getServiceItemFromProduct = (
  product,
  quantity = 1,
  isAnonymous = false
) => {
  if (Utils.IsNullOrEmptyObject(product)) {
    return {};
  }
  const branchDetails = getBranch();
  let isUAEBranch = BranchHelper.IsUAEBranch(branchDetails);
  let productPriceInclusive = product.priceIncludingTax;
  if (product.inclusiveOfTax && isUAEBranch) {
    let taxPercent = Utils.ConvertToFloat(product.taxPercent);
    let municipalTaxPercent = Utils.ConvertToFloat(
      branchDetails.isAllowMunicipalTax ? branchDetails.municipalTax : 0
    );
    let totalTaxPercent = Utils.ConvertToFloat(
      taxPercent + municipalTaxPercent
    );
    productPriceInclusive = (
      product.price *
      (1 + totalTaxPercent / 100)
    ).toFixed(2);
  }
  var totalPrice = getTotalPrice(product.price, quantity);
  var totalpriceIncludingTax = getTotalPrice(productPriceInclusive, quantity);
  var totalAmount = getTaxAmount(
    product.inclusiveOfTax,
    product.taxPercent,
    totalPrice,
    totalpriceIncludingTax
  );
  var taxamount = !branchDetails.isTaxBracket
    ? parseFloat(totalAmount[0].toFixed(2))
    : 0;
  var municipaltaxamount = parseFloat(totalAmount[1].toFixed(2));
  let packageProductDetails = [];
  if (!Utils.IsNullOrEmptyArray(product?.packageProductsList)) {
    packageProductDetails = reArrangePackageList(product?.packageProductsList);
  }
  var productprice = new Big(product.price);
  var totalprice = new Big(productprice.times(quantity));
  totalpriceIncludingTax = new Big(totalpriceIncludingTax).round(
    2,
    Big.roundHalfUp
  );
  var newtaxamount = !branchDetails.isTaxBracket ? totalAmount[0] : 0;
  taxamount = new Big(newtaxamount);
  municipaltaxamount = new Big(totalAmount[1]);
  var totalpriceincludingtax = totalprice
    .plus(taxamount)
    .plus(municipaltaxamount)
    .round(2, Big.roundHalfUp);
  var serviceItem = {
    Sequence: 0,
    Cost: product.cost,
    Description: product.shortDesc,
    BriefDescription: product.description,
    ProductHSN: product.hsn,
    Price: product.price,
    ProductClass: product.class,
    ProductCode: product.code || product.productCode,
    ProductDepartment: product.department,
    ProductFineline: product.fineline,
    ProductId: product.id,
    Quantity: quantity,
    DiscountTotal: 0,
    RetailPrice: product.retailPrice,
    MeasuringUnit: product.measuringUnit,
    Service: product.service,
    Labour: product.labour,
    Material: product.isMaterial,
    ServiceTime: product.serviceTime,
    TaxPercent: !branchDetails.isTaxBracket
      ? Utils.ConvertToFloat(product.taxPercent)
      : 0,
    TotalPrice: totalprice.toNumber(),
    IsAnonymous: isAnonymous,
    TotalPriceIncludingTax: totalpriceincludingtax.toNumber(),
    TaxAmount: taxamount.toNumber(),
    MunicipalTaxAmount: municipaltaxamount.toNumber(),
    Discounts: [],
    ServiceItemStaffs: [],
    ServiceItemProducts: product.serviceItemProducts,
    RefundTotal: 0,
    InclusiveOfTax: product.inclusiveOfTax,
    PriceIncludingTax: productPriceInclusive,
    IsWarrantyDetail: product.isWarrantyDetail,
    WarrantyDescription: product.warrantyDescription,
    IssueApprovalRequired: product.issueApprovalRequired,
    IssueStatus: product.issueStatus,
    PackageProductDetails: Utils.IsNullOrEmptyArray(
      product?.packageProductsList
    )
      ? null
      : packageProductDetails,
    MunicipalTaxPercent: Utils.ConvertToFloat(
      branchDetails.isAllowMunicipalTax ? branchDetails.municipalTax : 0
    ),
    WarrantyDuration: product.warrantyDuration,
    WarrantyRedemptionCount: product.warrantyRedemptionCount,
    WarrantyDurationUnit: product.warrantyDurationUnit,
  };
  return serviceItem;
};

const reArrangePackageList = (packageProductList) => {
  let arr = [];
  packageProductList.map((Package) => {
    let obj = {
      Description: Package.description,
      ShortDesc: Package.shortDesc,
      Code: Package.code,
      ServiceItemStaffs: [],
      Service: Package.service,
      OnOrderQuantity: Package.onOrderQuantity,
      IsWarrantyDetail: Package.isWarrantyDetail,
      WarrantyDescription: Package.warrantyDescription,
      WarrantyDuration: Package.warrantyDuration,
      WarrantyRedemptionCount: Package.warrantyRedemptionCount,
      WarrantyDurationUnit: Package.warrantyDurationUnit,
    };
    arr.push(obj);
  });

  return arr;
};

export const getServiceItemAMCPlan = (amcPlan) => {
  if (Utils.IsNullOrEmptyObject(amcPlan)) {
    return {};
  }
  var quantity = 1;
  var totalPrice = getTotalPrice(amcPlan.price, quantity);
  var totalpriceIncludingTax = getTotalPrice(
    amcPlan.priceIncludingTax,
    quantity
  );
  var totalAmount = getTaxAmount(
    amcPlan.inclusiveOfTax,
    amcPlan.taxPercent,
    totalPrice,
    totalpriceIncludingTax
  );
  var taxamount = totalAmount[0];

  var serviceItem = {
    Sequence: 0,
    Cost: amcPlan.cost,
    Description: amcPlan.name,
    ProductHSN: "",
    Price: amcPlan.price,
    ProductClass: "",
    ProductCode: "",
    ProductDepartment: "",
    ProductFineline: "",
    ProductId: amcPlan.id,
    Quantity: quantity,
    DiscountTotal: 0,
    RetailPrice: 0,
    MeasuringUnit: 0,
    Service: false,
    Labour: false,
    Material: 0,
    ServiceTime: 0,
    TaxPercent: amcPlan.taxPercent,
    TotalPrice: totalPrice,
    IsAnonymous: false,
    TotalPriceIncludingTax: totalPrice + taxamount,
    TaxAmount: taxamount,
    Discounts: [],
    ServiceItemStaffs: [],
    ServiceItemType: ServiceItemTypes.Plan,
    RefundTotal: 0,
    InclusiveOfTax: amcPlan.inclusiveOfTax,
    PriceIncludingTax: amcPlan.priceIncludingTax,
  };
  return serviceItem;
};
export const getBackPaymentPopup = ([AMCPLanDetails], quantity = 1) => {
  if (Utils.IsNullOrEmptyObject(AMCPLanDetails)) {
    return {};
  }
  var serviceItem = {
    Sequence: 0,
    cost: AMCPLanDetails.Cost,
    name: AMCPLanDetails.Description,
    ProductHSN: "",
    price: AMCPLanDetails.Price,
    ProductClass: "",
    ProductCode: "",
    ProductDepartment: "",
    ProductFineline: "",
    ProductId: AMCPLanDetails.id,
    Quantity: quantity,
    DiscountTotal: 0,
    RetailPrice: 0,
    MeasuringUnit: 0,
    Service: false,
    Labour: false,
    Material: 0,
    ServiceTime: 0,
    taxPercent: AMCPLanDetails.TaxPercent,
    paymentTotal: AMCPLanDetails.TotalPrice,
    IsAnonymous: false,
    TotalPriceIncludingTax: 0,
    paymentTax: AMCPLanDetails.TaxAmount,
    Discounts: [],
    ServiceItemStaffs: [],
    RefundTotal: 0,
  };
  return serviceItem;
};

export const getSpares = (products, isServiceItem = false) => {
  if (isServiceItem) {
    return getServiceItems(products);
  }
  return getProducts(products);
};

export const getLaboursOrServices = (products, isServiceItem = false) => {
  if (isServiceItem) {
    return getServiceItems(products, "", true);
  }
  return getProducts(products, "", true);
};

export const getServices = (products, isServiceItem = false) => {
  if (isServiceItem) {
    return getServiceItems(products, ServiceItemTypes.Service);
  }
  return getProducts(products, ServiceItemTypes.Service);
};

export const getConsumables = (products, isServiceItem = false) => {
  if (isServiceItem) {
    return getServiceItems(products, ServiceItemTypes.Consumable);
  }
  return getProducts(products, ServiceItemTypes.Consumable);
};

export const getLabours = (products, isServiceItem = false) => {
  if (isServiceItem) {
    return getServiceItems(products, ServiceItemTypes.Labour);
  }
  return getProducts(products, ServiceItemTypes.Labour);
};

const getProducts = (products, itemType = "", labourAndService = false) => {
  if (Utils.IsNullOrEmptyArray(products)) {
    return null;
  }
  if (labourAndService) {
    return products.filter((p) => p.labour || p.service);
  }
  var labour = false;
  var service = false;
  var consumable = false;
  switch (itemType) {
    case ServiceItemTypes.Service:
      service = true;
      break;
    case ServiceItemTypes.Consumable:
      consumable = true;
      break;
    case ServiceItemTypes.Labour:
      labour = true;
      break;
  }
  return products.filter(
    (p) =>
      p.labour === labour &&
      p.isMaterial === consumable &&
      p.service === service
  );
};

const getServiceItems = (items, itemType = "", labourAndService = false) => {
  if (Utils.IsNullOrEmptyArray(items)) {
    return null;
  }
  if (labourAndService) {
    return items.filter((p) => p.labour || p.service);
  }
  var labour = false;
  var service = false;
  var consumable = false;
  switch (itemType) {
    case ServiceItemTypes.Service:
      service = true;
      break;
    case ServiceItemTypes.Consumable:
      consumable = true;
      break;
    case ServiceItemTypes.Labour:
      labour = true;
      break;
  }
  return items.filter(
    (p) =>
      p.labour === labour && p.material === consumable && p.service === service
  );
};

const PackageProductStruct = (productDetails) => {
  console.log(productDetails);
  let store = [];
  if (!Utils.IsNullOrEmptyArray(productDetails)) {
    productDetails.map((item) => {
      let obj = {
        Class: item.class,
        Code: item.code,
        Description: item.description,
        OnOrderQuantity: item.onOrderQuantity,
        Service: item.service,
        ServiceItemStaffs: item.serviceItemStaffs,
        ShortDesc: item.shortDesc,
        IsWarrantyDetail: item.isWarrantyDetail,
        WarrantyDescription: item.warrantyDescription,
        WarrantyDuration: item.warrantyDuration,
        WarrantyRedemptionCount: item.warrantyRedemptionCount,
        WarrantyDurationUnit: item.warrantyDurationUnit,
      };
      store.push(obj);
    });
    return store;
  }

  return null;
};

export const convertServiceItemObject = (item, canConvertDiscount = false) => {
  if (Utils.IsNullOrEmpty(item)) {
    return {};
  }
  const branchDetails = getBranch();
  let isUAEBranch = BranchHelper.IsUAEBranch(branchDetails);
  let productPriceInclusive = item.priceIncludingTax;
  if (item.inclusiveOfTax && isUAEBranch) {
    let taxPercent = Utils.ConvertToFloat(item.taxPercent);
    let municipalTaxPercent = Utils.ConvertToFloat(
      branchDetails.isAllowMunicipalTax ? branchDetails.municipalTax : 0
    );
    let totalTaxPercent = Utils.ConvertToFloat(
      taxPercent + municipalTaxPercent
    );
    productPriceInclusive = (item.price * (1 + totalTaxPercent / 100)).toFixed(
      2
    );
  }

  var totalPrice = item.price * item.quantity;
  // var totalpriceIncludingTax = getTotalPrice(
  //   productPriceInclusive,
  //   item.quantity
  // );
  var totalpriceIncludingTax = productPriceInclusive * item.quantity;
  totalpriceIncludingTax = Number(totalpriceIncludingTax.toFixed(2));
  var totalAmount = getTaxAmount(
    item.inclusiveOfTax,
    item.taxPercent,
    totalPrice,
    totalpriceIncludingTax
  );
  var taxamount = totalAmount[0];
  var municipaltaxamount = totalAmount[1];
  var convertedServiceItemStaffs = [];
  item?.serviceItemStaffs?.forEach((staff) => {
    var newStaff = {
      Id: staff.id,
      Name: staff.name,
      Tip: staff.tip,
      AddStaffReview: staff.addStaffReview,
      ServicePersonRating: staff.servicePersonRating,
    };
    convertedServiceItemStaffs.push(newStaff);
  });
  var packageProductDetailsStruct = Utils.IsNullOrEmptyArray(
    item?.packageProductDetails
  )
    ? null
    : PackageProductStruct(item?.packageProductDetails);
  var serviceItem = {
    Sequence: item.sequence,
    Cost: item.cost,
    Description: item.description,
    BriefDescription: item.briefDescription,
    ProductHSN: item.productHSN,
    Price: item.price,
    DiscountTotal: 0,
    ProductClass: item.productClass,
    ProductCode: item.productCode,
    ProductDepartment: item.productDepartment,
    ProductFineline: item.productFineline,
    ProductId: item.productId,
    Quantity: item.quantity,
    RetailPrice: item.retailPrice,
    MeasuringUnit: item.measuringUnit,
    Service: item.service,
    Labour: item.labour,
    Material: item.material,
    ServiceTime: item.serviceTime,
    TaxPercent: Utils.ConvertToFloat(item.taxPercent),
    TotalPrice: item.totalPrice,
    IsAnonymous: item.isAnonymous,
    TotalPriceIncludingTax: totalPrice + taxamount + municipaltaxamount,
    TaxAmount: taxamount,
    MunicipalTaxAmount: municipaltaxamount,
    Discounts: [],
    ServiceItemStaffs: convertedServiceItemStaffs,
    ServiceItemProducts: item.serviceItemProducts,
    RefundTotal: item.refundTotal,
    InclusiveOfTax: item.inclusiveOfTax,
    PriceIncludingTax: productPriceInclusive,
    PackageProductDetails: packageProductDetailsStruct,
    IssueApprovalRequired: item.issueApprovalRequired,
    IssueStatus: item.issueStatus,
    IssueRecord: Utils.IsNullOrEmptyObject(item?.issueRecord)
      ? null
      : item?.issueRecord,
    MunicipalTaxPercent: Utils.ConvertToFloat(
      branchDetails.isAllowMunicipalTax ? branchDetails.municipalTax : 0
    ),
    BrandName: item.brandName || "",
    IsWarrantyDetail: item.isWarrantyDetail,
    WarrantyDescription: item.warrantyDescription,
    WarrantyDuration: item.warrantyDuration,
    WarrantyRedemptionCount: item.warrantyRedemptionCount,
    WarrantyDurationUnit: item.warrantyDurationUnit,
  };
  if (!Utils.IsNullOrEmptyArray(item.discounts) && canConvertDiscount) {
    var newTotalPrice = item.totalPrice - item.discountTotal;
    totalpriceIncludingTax = Utils.ConvertToFloat(
      (newTotalPrice * (item.taxPercent + 100)) / 100
    );
    taxamount = Utils.ConvertToFloat(totalpriceIncludingTax - newTotalPrice);
    var convertedDiscounts = [];
    item.discounts.forEach((discount) => {
      var newDiscount = {
        CampaignId: discount.campaignId,
        BenefitId: discount.benefitId,
        CampaignType: discount.campaignType,
        OffersClassificationType: discount.offersClassificationType,
        BenefitType: discount.benefitType,
        Code: discount.code,
        Description: discount.description,
        DescriptionDetail: discount.descriptionDetail,
        Quantity: discount.quantity,
        Complimentary: discount.complimentary,
        OrderLevel: discount.orderLevel,
        PointsRedemption: discount.pointsRedemption,
        DiscountType: discount.discountType,
        DiscountValue: discount.discountValue,
        DiscountTotal: discount.discountTotal,
      };
      convertedDiscounts.push(newDiscount);
    });
    serviceItem = {
      ...serviceItem,
      Discounts: convertedDiscounts,
      DiscountTotal: item.discountTotal,
      TotalPriceIncludingTax: totalpriceIncludingTax,
      TaxAmount: taxamount,
    };
  }
  return serviceItem;
};

export const getServiceItemProductsFromProduct = (product) => {
  if (Utils.IsNullOrEmptyObject(product)) {
    return {};
  }

  var serviceItem = {
    Description: product.shortDesc,
    ProductCode: product.code,
    ProductId: product.id,
    Quantity: 1,
    MeasuringUnit: product.measuringUnit,
    IsWarrantyDetail: product.isWarrantyDetail,
    WarrantyDescription: product.warrantyDescription,
    WarrantyDuration: product.warrantyDuration,
    WarrantyRedemptionCount: product.warrantyRedemptionCount,
    WarrantyDurationUnit: product.warrantyDurationUnit,
  };
  return serviceItem;
};

export const convertProductItemObject = (item) => {
  if (Utils.IsNullOrEmpty(item)) {
    return {};
  }
  var serviceItem = {
    Description: item.description,
    ProductCode: item.productCode,
    ProductId: item.productId,
    Quantity: item.quantity,
    MeasuringUnit: item.measuringUnit,
  };
  return serviceItem;
};
